import React from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Stack,
} from "@mui/material";
import ModalCardWithHeaderFooter from "../../../components/Cards/ModalCardWithHeaderFooter";

import {
  blackShade19,
  blueColor04,
  borderTextBoxColor,
  greenStatusColor01,
  greyColor060,
  greyColor53,
  greyColor54,
  greyColor56,
  heroSectionText,
  lightgreenColor04,
  lightYellowShade01,
  lightYellowShade02,
  oldPriceColor,
  whiteColor,
  yellowShade01,
} from "../../../configs/styles/muiThemes";
import { getColorChip } from "../../../utils/helper";
import { toTitleCase } from "../../../utils/validationUtils";

function AllSaleByAreaReport({ orderReportByCity }) {
  return (
    <ModalCardWithHeaderFooter title="Sales By Area" hideFooter>
    {/* <ModalCardWithHeaderFooter title="Top Selling Products" hideFooter> */}
      <Box sx={styles.tableWrapper}>
        <TableContainer sx={styles.tableContainer} component={Box}>
          <Table>
            <TableHead>
              <TableRow
                sx={{
                  position: "sticky !important",
                  top: 0,
                  zIndex: 20,
                  borderRadius: "8px",
                }}
              >
                <TableCell
                  sx={{ ...styles.tableCell, width: "80%" }}
                  align="center"
                >
                  City, State
                </TableCell>
                <TableCell sx={styles.tableCell} align="center">
                  Orders
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody sx={{ backgroundColor: whiteColor }}>
              {orderReportByCity?.slice(0, 50)?.map((item, index) => (
                <TableRow
                  key={index}
                  sx={{
                    borderBottom: `1px solid ${borderTextBoxColor}`,
                    verticalAlign: "top",
                  }}
                >
                  <TableCell sx={{ ...styles.tableBodyCell, maxWidth: "80%" }}>
                    <Box display="flex" gap="8px">
                      <Box
                        component="img"
                        src="/./assets/image/location-icon.svg"
                        sx={{
                          width: "20px",
                          height: "auto",
                        }}
                      />
                      <Box>
                        <Typography
                          sx={{
                            fontSize: 11.5,
                            fontWeight: 600,
                            color: blackShade19,
                            lineHeight: "16px",
                          }}
                        >
                          {toTitleCase(item?.cityState?.city)},{" "}
                          {toTitleCase(item?.cityState?.state)}
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: 12,
                            fontWeight: 400,
                            color: greyColor060,
                            lineHeight: "16px",
                          }}
                        >
                          {/* 530068 */}
                        </Typography>
                      </Box>
                    </Box>
                  </TableCell>
                  <TableCell sx={styles.tableBodyCell}>
                    <Box
                      sx={{
                        fontWeight: 600,
                        fontSize: "12px",
                        color: greenStatusColor01,
                        // textAlign: "center",
                      }}
                    >
                      {item?.orderCount}
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </ModalCardWithHeaderFooter>
  );
}

export default AllSaleByAreaReport;

const styles = {
  tableWrapper: {
    width: "100%",
    border: `2.5px solid ${greyColor56}`,
    borderBottom: "none",
    overflow: "hidden",
    borderRadius: "12px",
  },

  tableContainer: {
    maxWidth: "100%",
    borderRadius: "12px",
    overflowY: "scroll",
    maxHeight: "55vh",
    maxWidth: "100%",
    "&::-webkit-scrollbar": {
      width: "4px",
      height: "4px",
      borderRadius: "50px !important",
    },
    "&::-webkit-scrollbar-thumb": {
      // background: '#d0d3da',
      background: "rgba(0,0,0,0.1)",
    },
    "&::-webkit-scrollbar-track": {
      background: "rgba(0,0,0,0.05)",
    },
  },

  tableCell: {
    color: greyColor060,
    fontSize: "12px",
    fontWeight: "400",
    lineHeight: "16px",
    whiteSpace: "nowrap",
    padding: "8px 15px",
    backgroundColor: greyColor53,
    textAlign: "start",
    // borderRight: `1px solid ${whiteColor}`,
  },

  tableBodyCell: {
    fontSize: 12,
    fontWeight: 600,
    lineHeight: "16px",
    whiteSpace: "nowrap",
    color: blackShade19,
    padding: "10px 15px !important",
    textAlign: "start",
  },

  statusBoxChip: {
    backgroundColor: lightYellowShade01,
    border: "1px solid" + lightYellowShade02,
    borderRadius: "4px",
    width: "max-content",
    p: "0 4px",
    display: "flex",
    alignItems: "center",
    height: "20px",
  },
};
